
export function saveUsers(user) {
    localStorage.setItem('userData', JSON.stringify(user))
}

export function getSaveUsers() {
    let data = JSON.parse(localStorage?.getItem('userData'))
    return data

}

export function logoutClear() {
    localStorage.clear()

}
